<div class="auth-controls">
  @if (isAuthenticated()) {
    <mat-card class="user-card">
      <mat-card-content>
        <p class="welcome-text">Welcome, {{ userName() }}!</p>
        <button mat-raised-button color="warn" (click)="logout()">Logout</button>
      </mat-card-content>
    </mat-card>
  } @else {
    <mat-card class="login-card">
      <mat-card-content>
        <!-- <p class="login-prompt"></p> -->
        <button mat-raised-button color="primary" (click)="login()">
          Login with Microsoft
        </button>
      </mat-card-content>
    </mat-card>
  }
</div>
